import { RootState } from "@app/redux/root-reducer";

export const selectCreateOrderState = (store: RootState) =>
  store.createOrderReducer.createOrder;
